import './style.css';
import { fetchStations, fetchPredictions, fetchTrainPositions, fetchIncidents } from './api';
import { initMap, addStations, setStationClickHandler, updateTrainPositions } from './map';
import {
  initSearch,
  initThemeToggle,
  initUIEvents,
  initLocate,
  showStationPanel,
  updatePredictions,
  updateAlerts,
} from './ui';
import type { Station } from './api';

const PREDICTION_INTERVAL = 30_000;
const TRAIN_POS_INTERVAL = 15_000;
const INCIDENT_INTERVAL = 60_000;

let stations: Station[] = [];

async function boot() {
  // Init UI
  initThemeToggle();
  initUIEvents();
  initLocate();

  // Init map
  const map = initMap();

  // Set up station click → panel
  setStationClickHandler((_code, station) => {
    showStationPanel(station);
  });

  // Wait for map to load, then fetch all data in parallel
  map.on('load', async () => {
    await Promise.all([
      loadStations(),
      loadPredictions(),
      loadTrainPositions(),
      loadIncidents(),
    ]);

    // Set up refresh intervals
    setInterval(loadPredictions, PREDICTION_INTERVAL);
    setInterval(loadTrainPositions, TRAIN_POS_INTERVAL);
    setInterval(loadIncidents, INCIDENT_INTERVAL);
  });
}

async function loadStations() {
  try {
    stations = await fetchStations();
    addStations(stations);
    initSearch(stations);
  } catch (err) {
    console.error('Failed to load stations:', err);
  }
}

async function loadPredictions() {
  try {
    const predictions = await fetchPredictions();
    updatePredictions(predictions);
  } catch (err) {
    console.error('Failed to load predictions:', err);
  }
}

async function loadTrainPositions() {
  try {
    const positions = await fetchTrainPositions();
    updateTrainPositions(positions);
  } catch (err) {
    console.error('Failed to load train positions:', err);
  }
}

async function loadIncidents() {
  try {
    const incidents = await fetchIncidents();
    updateAlerts(incidents);
  } catch (err) {
    console.error('Failed to load incidents:', err);
  }
}

boot();
